import React from "react";

// Substitui @mui/material/Icon sem depender do MUI: renderiza um ícone da fonte
// Material Icons (já carregada no index.html) por ligadura, ex.: <Icon>edit</Icon>.
// Mantém compatibilidade com os usos existentes (className, onClick, fontSize).
const FONT_SIZE_MAP = { small: 20, medium: 24, large: 36 };

// Reproduz a "caixa" do @mui/material/Icon: limita o ícone a 1em × 1em com
// overflow oculto. Sem isso, ligaduras que não existem na fonte clássica
// Material Icons (ex.: "group_2", que é Material Symbols) vazam como texto e
// alargam o espaçamento. O uso de `em` mantém o tamanho proporcional ao
// font-size definido por className.
const BOX_STYLE = {
  width: "1em",
  height: "1em",
  overflow: "hidden",
  display: "inline-block",
  textAlign: "center",
  flexShrink: 0,
  userSelect: "none",
};

const Icon = ({ children, className = "", style, fontSize, ...rest }) => {
  const sizeStyle =
    fontSize && FONT_SIZE_MAP[fontSize]
      ? { fontSize: FONT_SIZE_MAP[fontSize] }
      : null;

  return (
    <span
      className={`material-icons ${className}`.trim()}
      style={{ ...BOX_STYLE, ...sizeStyle, ...style }}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Icon;
